import {
  getMeshFeedApi,
  getMyFeedApi,
  addReactionToFeedApi,
  removeReactionToFeedApi,
  getFeedDetailApi,
} from 'api/feed';
import FeedReactions from 'models/feedReactions';
import PostFeedItemData from 'models/postFeedItemData';

import { parseMeshFeedRes, FEED_TYPES } from './helpers/feed';
import { constructFiltersObject } from './task';

export const getMeshFeed = (offset = 0, limit = 8) => getMeshFeedApi().then((res) => parseMeshFeedRes(res.entity));

export const getMyFeed = ({ employeeId, offset = 0, limit = 8, pageType, filterTagType, filterId, filters }) =>
  getMyFeedApi({
    employeeId,
    offset,
    limit,
    pageType,
    filterTagType,
    filterId,
    filters: constructFiltersObject(filters),
  }).then((res) => parseMeshFeedRes(res.entity));

export function addReactionToFeed({ feedId, reactionType, feedType = FEED_TYPES.post }) {
  return addReactionToFeedApi({ feedId, reactionType, feedType }).then((res) => {
    const reactions = new FeedReactions();
    reactions.fromJSON(res.entity);
    return reactions;
  });
}

export function removeReactionToFeed({ feedId, reactionType, feedType = FEED_TYPES.post }) {
  return removeReactionToFeedApi({ feedId, reactionType, feedType }).then((res) => {
    const reactions = new FeedReactions();
    reactions.fromJSON(res.entity);
    return reactions;
  });
}

export function getFeedDetail(feedId) {
  return getFeedDetailApi(feedId).then((res) => {
    if (!res.entity || Object.keys(res.entity).length === 0) throw new Error('No feed data present');
    else return new PostFeedItemData(null, res.entity);
  });
}
